import React, { useState, forwardRef } from 'react';
import session_img from '../assets/svg/session_expired.svg'
import AppConfig from '../AppConfig';
import './session_expired.css'
import {
  Modal,
  Box,
  Grid,
  Typography,
  Button
} from '@mui/material';
const MyModal = ({ canShow
}) => {

  const handelRedirect = () => {
    window.location.replace(AppConfig.appRedirectUrl);
  }
  return (

    <Modal
      open={canShow}
      sx={{ border: 'none' }}>
      <Box className='semodal'   >
        <Grid style={{ display: 'flex', justifyContent: 'center' }} >
          <img src={session_img} alt='Session_img'></img>
        </Grid>

        <Grid style={{ display: 'flex', justifyContent: 'center', marginTop: '4%' }} >
          <Typography className='sehear' >
            your session has expired
          </Typography>
        </Grid>
        <Grid style={{ display: 'flex', justifyContent: 'center', marginTop: '4%' }} >
          <Typography className='sehear1'>
            We will navigate you to Trading Platform. Kindly login to console
          </Typography>
        </Grid>
        <Grid style={{ display: 'flex', justifyContent: 'center', marginTop: '4%' }} >
          <Button style={{ width: '100px' }}
            onClick={() => handelRedirect()}
          >
            ok
          </Button>
        </Grid>

      </Box>
    </Modal>


  );
};
export default MyModal;
